module.exports = __webpack_public_path__ + "media/application/images/ui/badge-peoples-choice-with-text-e77df6e791256ed2e5cf4192206f57b4.png";